export default [
    'https://testnet3.streamr.network:30401',
    'https://testnet3.streamr.network:30402',
    'https://testnet3.streamr.network:30403',
    'https://testnet3.streamr.network:30404',
    'https://testnet3.streamr.network:30405',
    'https://testnet4.streamr.network:30401',
    'https://testnet4.streamr.network:30402',
    'https://testnet4.streamr.network:30403',
    'https://testnet4.streamr.network:30404',
    'https://testnet4.streamr.network:30405',
]
